import { OtpType, VerificationAction } from '@core/models';

const EMAIL_ICON = 'bi-envelope-check';
const PHONE_ICON = 'bi-phone';
const AUTHENTICATOR_ICON = 'bi-shield-lock';

interface IVerificationUiEntry {
  medium: string;
  headline: string;
  info: string;
  icon: string;
}

export const VERIFICATION_UI_MATRIX: Partial<
  Record<VerificationAction, Partial<Record<OtpType, IVerificationUiEntry>>>
> = {
  signUp: {
    email: {
      medium: 'email',
      headline: 'Confirm Your Email',
      info: 'A confirmation code was sent to',
      icon: EMAIL_ICON
    },
    phone: {
      medium: 'phone',
      headline: 'Verify Your Phone',
      info: 'A confirmation code was sent to',
      icon: PHONE_ICON
    },
    authenticator: {
      medium: '',
      headline: 'Set Up Authenticator',
      info: 'Enter the code from your authenticator app',
      icon: AUTHENTICATOR_ICON
    }
  },
  login: {
    email: {
      medium: 'email',
      headline: 'Email Verification Code',
      info: 'A sign-in code was sent to',
      icon: EMAIL_ICON
    },
    phone: {
      medium: 'phone',
      headline: 'Phone Verification Code',
      info: 'A sign-in code was sent to',
      icon: PHONE_ICON
    },
    authenticator: {
      medium: '',
      headline: 'Authenticator Code',
      info: 'Enter the code from your authenticator app',
      icon: AUTHENTICATOR_ICON
    }
  },
  mfa: {
    email: {
      medium: 'email',
      headline: 'Multi-factor Verification',
      info: 'Enter the code sent to your email',
      icon: EMAIL_ICON
    },
    phone: {
      medium: 'phone',
      headline: 'Multi-factor Verification',
      info: 'Enter the code sent to your phone',
      icon: PHONE_ICON
    },
    authenticator: {
      medium: '',
      headline: 'Authenticator Verification',
      info: 'Enter the code from your authenticator app',
      icon: AUTHENTICATOR_ICON
    }
  }
} as const;
